//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BackendClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create an appointment.
     * @param body (optional) Details of the requested appointment.
     * @return The appointment is created.
     */
    apiAppointmentPost(body: AppointmentRequest | undefined): Promise<AppointmentResponse> {
        let url_ = this.baseUrl + "/api/Appointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAppointmentPost(_response);
        });
    }

    protected processApiAppointmentPost(response: Response): Promise<AppointmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppointmentResponse;
            return result201;
            });
        } else if (status === 207) {
            return response.text().then((_responseText) => {
            return throwException("The appointment is created, but the confirmation email was not sent.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The participant\'s user id doesn\'t match with the authenticated user. Or the user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("Participant, calendar or profile not exists.", status, _responseText, _headers, result404);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The requested time slot is not available.", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentResponse>(null as any);
    }

    /**
     * Create an appointment without registration.
     * @param body (optional) Details of the requested appointment.
     * @return The appointment is created.
     */
    apiAppointmentCreateWithoutRegistration(body: AppointmentRequestWithoutRegistration | undefined): Promise<AppointmentResponse> {
        let url_ = this.baseUrl + "/api/Appointment/createWithoutRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAppointmentCreateWithoutRegistration(_response);
        });
    }

    protected processApiAppointmentCreateWithoutRegistration(response: Response): Promise<AppointmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppointmentResponse;
            return result201;
            });
        } else if (status === 207) {
            return response.text().then((_responseText) => {
            return throwException("The appointment is created, but the confirmation email was not sent.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("User does not accept the privacy policy.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("Participant, calendar or profile not exists.", status, _responseText, _headers, result404);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The requested time slot is not available.", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentResponse>(null as any);
    }

    /**
     * List the appointments of the identified user.
     */
    apiAppointmentList(): Promise<AppointmentResponse[]> {
        let url_ = this.baseUrl + "/api/Appointment/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAppointmentList(_response);
        });
    }

    protected processApiAppointmentList(response: Response): Promise<AppointmentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppointmentResponse[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentResponse[]>(null as any);
    }

    /**
     * Delete an appointment.
     * @param id The id of the appointment you want to remove.
     */
    apiAppointmentDelete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Appointment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAppointmentDelete(_response);
        });
    }

    protected processApiAppointmentDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user id on appointment doesn\'t match with the user id on one time key.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The appointment or the one time key not found.", status, _responseText, _headers, result404);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The one time key expired.", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Confirm an appointment.
     * @param appointmentId (optional) The id of the appointment.
     * @param oneTimeKey (optional) The provided one time key.
     */
    apiAppointmentConfirm(appointmentId: number | undefined, oneTimeKey: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Appointment/confirm?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "appointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        if (oneTimeKey === null)
            throw new Error("The parameter 'oneTimeKey' cannot be null.");
        else if (oneTimeKey !== undefined)
            url_ += "oneTimeKey=" + encodeURIComponent("" + oneTimeKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAppointmentConfirm(_response);
        });
    }

    protected processApiAppointmentConfirm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect, or the appointment belongs to someone else.", status, _responseText, _headers, result400);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The appoientment was deleted.", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Terminate an appointment.
     * @param appointmentId (optional) The id of the appointment.
     * @param oneTimeKey (optional) The provided one time key.
     */
    apiAppointmentTerminate(appointmentId: number | undefined, oneTimeKey: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Appointment/terminate?";
        if (appointmentId === null)
            throw new Error("The parameter 'appointmentId' cannot be null.");
        else if (appointmentId !== undefined)
            url_ += "appointmentId=" + encodeURIComponent("" + appointmentId) + "&";
        if (oneTimeKey === null)
            throw new Error("The parameter 'oneTimeKey' cannot be null.");
        else if (oneTimeKey !== undefined)
            url_ += "oneTimeKey=" + encodeURIComponent("" + oneTimeKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAppointmentTerminate(_response);
        });
    }

    protected processApiAppointmentTerminate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect, or the appointment belongs to someone else.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The one time key not found.", status, _responseText, _headers, result404);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The appointment not exists or the key is expired.", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Login a user.
     * @param body (optional) The user's email and password.
     */
    apiAuthLogin(body: LoginRequest | undefined): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthLogin(_response);
        });
    }

    protected processApiAuthLogin(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The login failed.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(null as any);
    }

    /**
     * Register a user.
     * @param body (optional) The user's data.
     */
    apiAuthRegister(body: RegisterRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthRegister(_response);
        });
    }

    protected processApiAuthRegister(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("Unknown language", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user doesn\'t accept the privacy terms.", status, _responseText, _headers, result401);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user already exists", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Activate a user.
     * @param key (optional) A one time key.
     */
    apiAuthActivate(key: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/activate?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthActivate(_response);
        });
    }

    protected processApiAuthActivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The one time key or the user not exists.", status, _responseText, _headers, result404);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The one time key expired.", status, _responseText, _headers, result410);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("The user already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Handles a password reset request for a user by generating and saving a one-time token.
     * @param body (optional) The user's email.
     */
    apiAuthForgottenPassword(body: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/forgottenPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthForgottenPassword(_response);
        });
    }

    protected processApiAuthForgottenPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("Unknown language", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user not exists.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Resets a user's password based on a valid one-time token and the new password provided in the request.
     * @param body (optional) The new password and a one time key.
     */
    apiAuthUpdatePassword(body: UpdatePasswordRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/updatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthUpdatePassword(_response);
        });
    }

    protected processApiAuthUpdatePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("If the user or the one time key not exists.", status, _responseText, _headers, result404);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("If the one time key expired.", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Searching for calendar slots within the specified period.
     * @param body (optional) Search parameters
     */
    apiCalendar(body: CalendarRequest | undefined): Promise<CalendarResponse> {
        let url_ = this.baseUrl + "/api/Calendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiCalendar(_response);
        });
    }

    protected processApiCalendar(response: Response): Promise<CalendarResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The calendar not found.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarResponse>(null as any);
    }

    /**
     * List clinics.
     */
    apiClinicsList(): Promise<ClinicsResponse> {
        let url_ = this.baseUrl + "/api/Clinics/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiClinicsList(_response);
        });
    }

    protected processApiClinicsList(response: Response): Promise<ClinicsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClinicsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicsResponse>(null as any);
    }

    /**
     * Create a favourite doctor for the identified user.
     * @param body (optional) The favourite's data.
     */
    apiFavouritePost(body: CreateFavouriteRequest | undefined): Promise<FavouriteResponse> {
        let url_ = this.baseUrl + "/api/Favourite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavouritePost(_response);
        });
    }

    protected processApiFavouritePost(response: Response): Promise<FavouriteResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FavouriteResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The doctor or the clinic not exists.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The favourite already exists.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavouriteResponse>(null as any);
    }

    /**
     * List the identified user's favourites.
     */
    apiFavouriteGet(): Promise<FavouriteResponse[]> {
        let url_ = this.baseUrl + "/api/Favourite";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavouriteGet(_response);
        });
    }

    protected processApiFavouriteGet(response: Response): Promise<FavouriteResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FavouriteResponse[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavouriteResponse[]>(null as any);
    }

    /**
     * Delete a favourite.
     * @param favouriteId The id of the favourite you want to remove.
     */
    apiFavouriteDelete(favouriteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Favourite/{favouriteId}";
        if (favouriteId === undefined || favouriteId === null)
            throw new Error("The parameter 'favouriteId' must be defined.");
        url_ = url_.replace("{favouriteId}", encodeURIComponent("" + favouriteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavouriteDelete(_response);
        });
    }

    protected processApiFavouriteDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect, or the favourite belongs to someone else.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a participant
     * @param id The participant's id.
     */
    apiParticipantGet(id: number): Promise<ParticipantResponse> {
        let url_ = this.baseUrl + "/api/Participant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiParticipantGet(_response);
        });
    }

    protected processApiParticipantGet(response: Response): Promise<ParticipantResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ParticipantResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The participant\'s user id doesn\'t match with the authenticated user. Or the user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The participant not exists.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParticipantResponse>(null as any);
    }

    /**
     * Delete a participant.
     * @param id The id of the participant you want to remove.
     */
    apiParticipantDelete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Participant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiParticipantDelete(_response);
        });
    }

    protected processApiParticipantDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect, or the participant belongs to someone else.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * List the identified user's participants.
     */
    apiParticipantListByUser(): Promise<ParticipantResponse[]> {
        let url_ = this.baseUrl + "/api/Participant/listByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiParticipantListByUser(_response);
        });
    }

    protected processApiParticipantListByUser(response: Response): Promise<ParticipantResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ParticipantResponse[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParticipantResponse[]>(null as any);
    }

    /**
     * Create a participant.
     * @param body (optional) Details of the participant.
     */
    apiParticipantPost(body: CreateParticipantRequest | undefined): Promise<ParticipantResponse> {
        let url_ = this.baseUrl + "/api/Participant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiParticipantPost(_response);
        });
    }

    protected processApiParticipantPost(response: Response): Promise<ParticipantResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ParticipantResponse;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParticipantResponse>(null as any);
    }

    /**
     * Update a participant.
     * @param body (optional) Details of the participant.
     */
    apiParticipantPut(body: UpdateParticipantRequest | undefined): Promise<ParticipantResponse> {
        let url_ = this.baseUrl + "/api/Participant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiParticipantPut(_response);
        });
    }

    protected processApiParticipantPut(response: Response): Promise<ParticipantResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ParticipantResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The participant\'s user id doesn\'t match with the authenticated user. Or the user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParticipantResponse>(null as any);
    }

    /**
     * Returns the legacy settings.
     */
    apiSettingsLegacySettings(): Promise<LegacySettingsResponse> {
        let url_ = this.baseUrl + "/api/Settings/legacySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSettingsLegacySettings(_response);
        });
    }

    protected processApiSettingsLegacySettings(response: Response): Promise<LegacySettingsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LegacySettingsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegacySettingsResponse>(null as any);
    }

    /**
     * Returns the error list.
     */
    apiSettingsErrorList(): Promise<ErrorConfiguration> {
        let url_ = this.baseUrl + "/api/Settings/errorList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSettingsErrorList(_response);
        });
    }

    protected processApiSettingsErrorList(response: Response): Promise<ErrorConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorConfiguration;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ErrorConfiguration>(null as any);
    }

    /**
     * Returns the uniqe options.
     */
    apiSettingsUniqeOptions(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Settings/uniqeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSettingsUniqeOptions(_response);
        });
    }

    protected processApiSettingsUniqeOptions(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Returns client configuration
     */
    apiSettingsClientConfiguration(): Promise<ClientConfiguration> {
        let url_ = this.baseUrl + "/api/Settings/clientConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSettingsClientConfiguration(_response);
        });
    }

    protected processApiSettingsClientConfiguration(response: Response): Promise<ClientConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientConfiguration;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientConfiguration>(null as any);
    }

    /**
     * Returns the identified user.
     */
    apiUserGet(): Promise<UserResponse> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUserGet(_response);
        });
    }

    protected processApiUserGet(response: Response): Promise<UserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user not exists.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserResponse>(null as any);
    }

    /**
     * Update a user.
     * @param body (optional) Details of the user.
     */
    apiUserPut(body: UpdateUserRequest | undefined): Promise<UserResponse> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUserPut(_response);
        });
    }

    protected processApiUserPut(response: Response): Promise<UserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user not exists.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserResponse>(null as any);
    }

    /**
     * Delete the identified user.
     */
    apiUserDelete(): Promise<void> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUserDelete(_response);
        });
    }

    protected processApiUserDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update the identified user's password
     * @param body (optional) The old and the new password.
     */
    apiUserUpdatePassword(body: UpdateUserPasswordRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/User/updatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUserUpdatePassword(_response);
        });
    }

    protected processApiUserUpdatePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user ID is incorrect or the password is empty.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("The user not exists.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface Address {
    postalCode?: number | undefined;
    city?: string | undefined;
    streetAddress?: string | undefined;
    publicAreaName?: string | undefined;
    publicAreaType?: string | undefined;
    houseNumber?: string | undefined;
    building?: string | undefined;
    staircase?: string | undefined;
    floor?: string | undefined;
    door?: string | undefined;
    district?: string | undefined;
    countryCode?: string | undefined;
    phone?: string | undefined;
    homePhone?: string | undefined;
}

export interface AppointmentRequest {
    participantId?: number;
    profileId?: number;
    dateTime?: Date;
    notes?: string | undefined;
    isTelemedical?: boolean;
    selectedUniqeOption?: string | undefined;
    phone?: string | undefined;
}

export interface AppointmentRequestWithoutRegistration {
    participantId?: number;
    profileId?: number;
    dateTime?: Date;
    notes?: string | undefined;
    isTelemedical?: boolean;
    selectedUniqeOption?: string | undefined;
    phone?: string | undefined;
    email: string;
    password?: string | undefined;
    name: string;
    ssn?: string | undefined;
    birthDate?: Date | undefined;
    address?: Address;
    ssnConsent?: boolean;
    dataPrivacyNoticeAccepted?: boolean;
    gender?: Gender;
    permanentRegistration?: boolean;
}

export interface AppointmentResponse {
    id?: number;
    userId?: number;
    participantId?: number;
    profileId?: number;
    dateTime?: Date;
    notes?: string | undefined;
    state?: AppointmentState;
    createdAt?: Date;
}

export enum AppointmentState {
    None = "None",
    WaitingForConfirmationConfirmationEmailNotSentYet = "WaitingForConfirmationConfirmationEmailNotSentYet",
    WaitingForConfirmationConfirmationEmailSent = "WaitingForConfirmationConfirmationEmailSent",
    ConfirmedNotSychronized = "ConfirmedNotSychronized",
    ConfirmedAndSychronized = "ConfirmedAndSychronized",
    DeletedByUser = "DeletedByUser",
    ExcludedByDoctor = "ExcludedByDoctor",
    DeletedByDoctor = "DeletedByDoctor",
    DeletedByDoctorInHIS = "DeletedByDoctorInHIS",
    RejectedByDoctor = "RejectedByDoctor",
    DoctorDayOff = "DoctorDayOff",
}

export interface CalendarRequest {
    profileId?: number;
    from?: Date;
    to?: Date;
    participantId?: number;
    userId?: number;
    firstAvailable?: boolean;
}

export interface CalendarResponse {
    slots?: Slot[] | undefined;
    officeHours?: OfficeHour[] | undefined;
    nextAvailableSlotDate?: Date | undefined;
}

export interface ClientConfiguration {
    globalLog?: boolean;
    logLevel?: number;
    mode?: ClientMode;
    subMode?: string[] | undefined;
    slogan1?: string | undefined;
    slogan2?: string | undefined;
    gtmId?: string | undefined;
}

export enum ClientMode {
    Infomix = "infomix",
    Szakrendelo = "szakrendelo",
    Magan = "magan",
}

export interface Clinic {
    id?: number;
    name?: string | undefined;
    doctors?: Doctor[] | undefined;
    professionName?: string | undefined;
    profession?: number;
    address?: Address;
    imagePath?: string | undefined;
}

export interface ClinicsResponse {
    clinics?: Clinic[] | undefined;
}

export interface CreateFavouriteRequest {
    clinicId?: number;
    doctorId?: number;
}

export interface CreateParticipantRequest {
    name: string;
    ssn?: string | undefined;
    birthDate?: Date | undefined;
    phone?: string | undefined;
    address?: Address;
    gender?: Gender;
}

export interface Doctor {
    id?: number;
    name?: string | undefined;
    profiles?: Profile[] | undefined;
}

export interface ErrorCode {
    code?: string | undefined;
    languages?: { [key: string]: string; } | undefined;
}

export enum ErrorCodes {
    IncorrectEmailOrPassword = "IncorrectEmailOrPassword",
    UserAlreadyRegistered = "UserAlreadyRegistered",
    DataPrivacyNotAccepted = "DataPrivacyNotAccepted",
    UserNotActivated = "UserNotActivated",
    OneTimeKeyNotFound = "OneTimeKeyNotFound",
    OneTimeKeyExpired = "OneTimeKeyExpired",
    UserNotExists = "UserNotExists",
    TokenHasNoNameClaim = "TokenHasNoNameClaim",
    UserIdIsIncorrect = "UserIdIsIncorrect",
    PasswordIsEmpty = "PasswordIsEmpty",
    UserIdMismatch = "UserIdMismatch",
    ParticipantNotFound = "ParticipantNotFound",
    FavouriteAlreadyExists = "FavouriteAlreadyExists",
    ClinicNotExists = "ClinicNotExists",
    DoctorNotExists = "DoctorNotExists",
    CalendarNotFound = "CalendarNotFound",
    SlotIsNotAvailable = "SlotIsNotAvailable",
    AppointmentNotExists = "AppointmentNotExists",
    UserIdMismatchOnAppointment = "UserIdMismatchOnAppointment",
    SSNRequired = "SSNRequired",
    UniqeOptionRequired = "UniqeOptionRequired",
    CommentRequired = "CommentRequired",
    PrequisitsValidationFailed = "PrequisitsValidationFailed",
    PatientAgeIsInappropriate = "PatientAgeIsInappropriate",
    ProfileNotFound = "ProfileNotFound",
    PhoneRequired = "PhoneRequired",
    UnknownMessageName = "UnknownMessageName",
    EmailTemplateNotExists = "EmailTemplateNotExists",
    EmailSubjectNotExists = "EmailSubjectNotExists",
    UnknownError = "UnknownError",
    PasswordIsIncorrect = "PasswordIsIncorrect",
    UserIsNotValid = "UserIsNotValid",
    PatientAgeIsInappropriateForUnregisteredUser = "PatientAgeIsInappropriateForUnregisteredUser",
    AppontmentDeleted = "AppontmentDeleted",
    AddressForbidden = "AddressForbidden",
}

export interface ErrorConfiguration {
    errorCodes?: ErrorCode[] | undefined;
}

export interface ErrorResponse {
    errorCode?: ErrorCodes;
}

export interface FavouriteResponse {
    id?: number;
    userId?: number;
    clinicId?: number;
    doctorId?: number;
}

export enum Gender {
    Female = "Female",
    Male = "Male",
}

export interface LegacySettingsResponse {
    countyMode?: boolean;
    providerName?: string | undefined;
    providerAddress?: string | undefined;
    providerPhone?: string | undefined;
    providerAppointmentPhone?: string | undefined;
    ssnRequired?: boolean;
    birthDateRequired?: boolean;
    addressRequired?: boolean;
    phoneRequired?: boolean;
    requiredPhoneQuestion?: boolean;
    providerEmail?: string | undefined;
    commentRequired?: boolean;
    appointmentActivationRequired?: boolean;
}

export interface LoginRequest {
    email?: string | undefined;
    password?: string | undefined;
}

export interface OfficeHour {
    from?: Date;
    to?: Date;
    status?: OfficeHourStatus;
}

export enum OfficeHourStatus {
    OfficeHoursWeb = "OfficeHoursWeb",
    OfficeHoursLocal = "OfficeHoursLocal",
}

export interface ParticipantResponse {
    id?: number;
    userId?: number;
    name?: string | undefined;
    ssn?: string | undefined;
    birthDate?: Date | undefined;
    phone?: string | undefined;
    address?: Address;
    gender?: Gender;
}

export interface Profile {
    id?: number;
    clinicId?: number;
    doctorId?: number;
    name?: string | undefined;
    phoneRequired?: boolean;
    showUniqeOptions?: boolean;
    description?: string | undefined;
    activity?: string | undefined;
}

export interface RegisterRequest {
    email: string;
    password: string;
    name: string;
    ssn?: string | undefined;
    birthDate?: Date | undefined;
    address?: Address;
    ssnConsent?: boolean;
    dataPrivacyNoticeAccepted?: boolean;
    phone?: string | undefined;
    gender?: Gender;
}

export interface Slot {
    from?: Date;
    to?: Date;
}

export interface TokenResponse {
    token?: string | undefined;
    expiresAt?: Date;
}

export interface UpdateParticipantRequest {
    id: number;
    name: string;
    ssn?: string | undefined;
    birthDate?: Date | undefined;
    phone?: string | undefined;
    address?: Address;
    gender?: Gender;
}

export interface UpdatePasswordRequest {
    key: string;
    password: string;
}

export interface UpdateUserPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export interface UpdateUserRequest {
    name?: string | undefined;
    email?: string | undefined;
    birthDate?: Date | undefined;
    ssn?: string | undefined;
    address?: Address;
    phone?: string | undefined;
    ssnConsent?: boolean;
    gender?: Gender;
}

export interface UserResponse {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    birthDate?: Date | undefined;
    ssn?: string | undefined;
    address?: Address;
    phone?: string | undefined;
    ssnConsent?: boolean;
    activated?: boolean;
    gender?: Gender;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}